import { z } from 'zod'
import { rentabilitySchema } from '@/modules/settings/tasa/types/types.ts'

export const clientCreditDebtSchema = z.object({
  credit: z.number(),
  clientLasName: z.string(),
  clientName: z.string(),
  initialByLevel: z.string(),
  applePercent: z.union([z.string(), z.number()]).nullable().optional(),
  rentabilityId: z.string().optional()
})

export type ClientCreditDebt = z.infer<typeof clientCreditDebtSchema>

export const calculatorFormSchemaBasic = z.object({
  cedula: z.string().nonempty('Requerido'),
  credit: z.string().nonempty('Requerido'),
  article: z.string().optional(),
  category: z.string().optional(),
  brand: z.string().nonempty('Requerido'),
  model: z.string().nonempty('Requerido'),
  cost: z.string().nonempty('Requerido'),
  _creditLimit: z.string().optional(),
  rentability: z.string({ message: 'Requerido' }),
  payment_extra: z.string().optional()
})

export const calculatorFormSchema = calculatorFormSchemaBasic

export type calculatorFormSchema = z.infer<typeof calculatorFormSchema>

export const promotionSchema = z.object({
  id: z.number(),
  name: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  initialPercentage: z.string(),
  noCreditLimits: z.boolean(),
  rentability: rentabilitySchema
})

export const promotionApiResponseScehma = z.object({
  promotion: promotionSchema.nullable().optional()
})

export type Promotion = z.infer<typeof promotionSchema>

export type promotionApiResponseScehma = z.infer<
  typeof promotionApiResponseScehma
>
